import { addMonths, formatDistanceToNowStrict, set } from 'date-fns';

import { getDateFnsLocale } from 'common/locale';

/**
 * If today is before the 5th of the current month, return distance between today and the 5th of the current month
 * Otherwise return distance between today and the 5th of the next month
 * @returns - The distance between now and a given date in words (ex: in 5 days)
 * @see https://date-fns.org/v2.22.1/docs/formatDistanceToNow
 */
export const formatExportNextDate = () => {
  const locale = getDateFnsLocale();
  const today = new Date();

  if (today.getDate() < 5) {
    return formatDistanceToNowStrict(set(today, { date: 5 }), {
      addSuffix: true,
      locale,
    });
  }
  return formatDistanceToNowStrict(set(addMonths(today, 1), { date: 5 }), {
    addSuffix: true,
    locale,
  });
};
